import { render, staticRenderFns } from "./GridPlanificacion.vue?vue&type=template&id=96d04810&"
import script from "./GridPlanificacion.vue?vue&type=script&lang=js&"
export * from "./GridPlanificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports